import request from '@/utils/request'

// 排行榜
export function rankList(data) {
  return request({
    url: 'index/Activity/Rankings',
    method: 'get',
    params: data
  })
}

// 学校信息新增
export function addSchool(data) {
  return request({
    url: 'index/Activity/schoolInfo',
    method: 'post',
    data: data
  })
}

// 获取学校列表
export function getSchoolList(data) {
  return request({
    url: 'wechat/Base/schoolList',
    method: 'get',
    params: data
  })
}

// 获取活动报名详情
export function getActivityEnroll(data) {
  return request({
    url: 'index/Activity/enroll',
    method: 'get',
    params: data
  })
}

// 活动报名记录
export function getUserInfo(data) {
  return request({
    url: 'index/Activity/enrollRecord',
    method: 'get',
    params: data
  })
}

// 报名
export function enrollAdd(data) {
  return request({
    url: 'index/Activity/enrollAdd',
    method: 'post',
    data: data
  })
}

// 获取地区
export function getAreaList(data) {
  return request({
    url: 'admin/Base/areaList',
    method: 'get',
    params: data
  })
}

// 获取用户信息
export function getUserData(data) {
  return request({
    url: 'index/Activity/Users',
    method: 'get',
    params: data
  })
}
